import * as React from 'react';
import { Warning } from '../../../atoms/membership_plans/Warning';
import './planUpdateWarning.module.scss';

export const PlanUpdateWarning = () => {
    const url = 'https://support.she-inc.jp/hc/ja/articles/1500002597221';
    return (
        <div styleName="plan-update-warning">
            <Warning id="plan-update-warning">
                プランを変更する場合、次回お支払い日の10日前までにお申し込みください。<br />
                10日前を過ぎてプラン変更をお申し込みいただいた場合次々回からの変更適応となります。<br />
                休会復帰後にプラン変更をご希望の場合は、休会復帰日の10日前までに<a href={url} target="_blank">
                    SHE公式LINE＠へご連絡
                </a>をお願いいたします。
            </Warning>
        </div>
    );
};
